var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"kfplatform": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_audit_index_jsx":1,"src_explorer_index_jsx":1,"src_myitems_index_jsx-src_components_empty_state_empty_state_css-src_components_grid_and_pagi-e48ce6":1,"src_mytasks_index_jsx-src_components_empty_state_empty_state_css-src_components_grid_and_pagi-8194fc":1,"src_explorer_createWorkflow_index_jsx":1,"common_src_constant_globaltask_constants_js-common_src_utils_index_jsx-src_search_search_comp-03cd79":1,"src_search_home_index_jsx":1,"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_objectSpread2_j-4f9719":1,"src_notification_home_index_jsx":1,"src_notification_notification_setting_modal_js":1,"src_notification_notification_preference_js":1,"vendors-node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_createF-9f213c":1,"src_filepicker_index_js":1,"src_filepreview_plugins_index_jsx":1,"src_pdf_generation_index_jsx-src_pdf_generation_components_field_menu_styles_css-src_pdf_gene-91d765":1,"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_objectSpread2_j-1b1bb6":1,"src_importform_index_js":1,"src_myspace_index_jsx":1,"src_components_impersonation_index_jsx":1,"src_components_custom_select_index_jsx":1,"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_createForOfIter-39103a":1,"src_explorer_revamp_template_index_jsx-src_explorer_revamp_components_flow_card_flowCard_css--6dea3b":1,"src_explorer_revamp_create_new_index_jsx":1,"src_explorer_revamp_components_flow_layout_container_index_jsx-src_explorer_revamp_components-c96599":1,"src_explorer_revamp_archived_index_jsx":1,"src_explorer_revamp_index_jsx":1,"src_explorer_market_create_flow_index_jsx":1,"src_search_quick_search_index_jsx":1,"src_filepreview_xlspreview_index_jsx":1,"src_filepreview_txtpreview_index_jsx":1,"src_myspace_mytasks_index_jsx-src_myspace_shared_components_date_field_styles_css-src_myspace-521e12":1,"src_myspace_myitems_index_jsx-src_myspace_shared_components_date_field_styles_css-src_myspace-7e5d06":1,"src_myspace_admin_tasks_index_jsx":1,"src_explorer_revamp_template_template_install_dialog_index_jsx":1,"src_myspace_item_reassignment_index_jsx-src_myspace_shared_components_flow_card_style_css-src-304e05":1,"src_myspace_flow_approval_index_jsx-src_myspace_shared_components_flow_card_style_css-src_mys-bb798c":1,"src_myspace_admin_assignment_index_jsx-src_myspace_shared_components_flow_card_style_css-src_-6b9032":1,"src_myspace_join_requests_index_jsx-src_myspace_shared_components_flow_card_style_css-src_mys-ff4ced":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr